module.exports = __webpack_public_path__ + "assets/images/a3f8bf38a0628f798f3581c9226608de.png";